// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__exJ22","comment":"styles_comment__35kAd"};